import { z } from "zod/v4";

/**
 * The Shopify coverage an Intelligems rate group replaces under the Markets
 * shipping model: one market, plus the collection and origin-location
 * conditions of the merchant rate group it stands in for. This is the same
 * tuple a carrier placement is keyed on, so a scoped rate group and the
 * placement that serves it match by construction.
 *
 * A rate group carries a list of these. An empty or absent list is served by
 * every placement, which is the pre-scoping behaviour and what legacy-model
 * tests always use; a non-empty list is served only at those coverages.
 */
export const MarketRateScopeSchema = z.object({
  marketId: z.string().min(1),
  /** `null` means the merchant rate applied to all products. */
  collectionIds: z.array(z.string().min(1)).nullable(),
  originLocationIds: z.array(z.string().min(1)),
});

export type MarketRateScope = z.infer<typeof MarketRateScopeSchema>;
